import { defineStore } from 'pinia'
import { markRaw } from 'vue'

export const useModalStore = defineStore('modal', {
  state: () => ({
    isOpen: false,
    view: null,
    title: '',
    description: '',
    headerIcon: null,
    buttons: [],
    listeners: {},
    props: {},
    onClose: null,
  }),
  actions: {
    open(options) {
      this.isOpen = true
      this.view = options.view ? markRaw(options.view) : null
      this.title = options.title
      this.description = options.description
      this.headerIcon = options.headerIcon ? markRaw(options.headerIcon) : null
      this.buttons = options.buttons
      this.listeners = options.listeners ?? {}
      this.props = options.props ?? {}
      this.onClose = options.onClose ?? null
    },
    close() {
      const onClose = this.onClose

      this.isOpen = false
      this.view = null
      this.title = ''
      this.description = ''
      this.headerIcon = null
      this.buttons = []
      this.listeners = {}
      this.props = {}
      this.onClose = null

      if (typeof onClose === 'function') {
        onClose()
      }
    },
  },
})
